
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useState,useEffect, Suspense } from 'react';
import './App.css';
import { ThemeProvider, createTheme } from '@mui/material/styles'; 
import { axiosInstance, createAxiosResponseInterceptor, setHeaders } from "./redux/Thunk/axiosHelper"; 
import { useNavigate } from 'react-router-dom';
import {theme} from './theme/Theme';
import ProtectedRoute from './routing/ProtectedRoute';
import Routing from './routing/Routing';
import Header from './components/Sidebar/Header';
import PageLoader from './components/Loader/PageLoader';
import Dashboard from './pages/Dashboard/Dashboard';
import Shared from './routing/Shared';

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem("accessToken"));

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      setHeaders("x-access-token", token);
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
      if (location.pathname !== "/" && location.pathname !== "/forgotpassword") {
        navigate("/");
      }
    }

    createAxiosResponseInterceptor();
  }, [location.pathname]);

  return (

    <ThemeProvider theme={theme}>
      <Suspense fallback={<PageLoader />}>
        {isAuthenticated ? <ProtectedRoute /> : <Routing />}
      </Suspense>
    </ThemeProvider>
  
  );
}

export default App;